import React, { useEffect } from 'react';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { animateScroll } from 'react-scroll';
import { getPageStaticProps } from 'lib/dato-request';
import { MUZOLOGY_APP, MUZOLOGY_SIGNUP_URL } from '@/lib/defaults';
import { Layout } from '@/components/Layout';
import { LargeHeading } from '@/components/Views/Heading';
import ParentsCTA from '@/components/Parents/ParentsCTA';
import IconBlock from '@/components/Animations/IconBlock';
import { LargeText } from '@/components/Views/Text';
import IconRightDelta from '@/components/SVG/right-delta.svg';
import { useDispatchUi } from '@/context/ui';
import FormTeacherTrialSignup from '@/components/FormTeacherTrialSignup/FormTeacherTrialSignup';
import BottomSection from '@/components/Subscription/BottomSection';
import BalanceText from '@/components/BalanceText/BalanceText';
import { useRouter } from 'next/router';
import { useAnalytics } from '@/analytics/AnalyticsProvider';

const Signup = ({ data }) => {
    const analytics = useAnalytics();
    const { page } = data;
    const { components, seo } = page;
    const dispatch: any = useDispatchUi();
    const desktopFloatingHeartsPositions = [
        { top: '6%', left: '1%', rotate: 22, scale: 1, opacity: 1 },
        { top: '30%', left: '94%', rotate: 344, scale: 1.2, opacity: 1 },
        { top: '73%', left: '85%', rotate: 25, scale: 1, opacity: 1 },
        { top: '53%', left: '8%', rotate: 345, scale: 1.25, opacity: 1 }
    ];
    const router = useRouter();
    const { email, token } = router.query ?? {};

    useEffect(() => {
        console.log('page loaded: signup', analytics);
        analytics.page('Teacher Signup');
    }, [analytics]);

    const handleParentClickBack = () => {
        analytics.page("Clicked 'Are you a Parent?' link on Teacher Signup page");
        router.push({
            pathname: MUZOLOGY_SIGNUP_URL,
            query: {
                ...router.query,
                email,
                token
            }
        });

        // router.push(
        //     {
        //         pathname: MUZOLOGY_SIGNUP_URL,
        //         query: {
        //             ...router.query,
        //             email,
        //             token
        //         }
        //     },
        //     undefined,
        //     { shallow: true }
        // );
    };

    return (
        <Layout showLoginAndSignup={true}>
            <NextSeo title={seo?.title ?? page.slug} description={seo?.description} />
            <Head>
                <meta name='keywords' content={page.keywords} />
            </Head>
            <div className='bg-white font-Inter relative pt-[120px] xl:pt-[100px]'>
                <div className='w-full relative' id='teacher-form'>
                    <div
                        // style={{ backgroundSize: '100%' }}
                        className='max-w-[1000px] mx-auto -bg-blue-400 z-0 bg-no-repeat bg-top bg-contain absolute left-0 right-0 top-[0] bottom-[0] bg-[url("/backgrounds/background-blobs-2.svg")] '
                    />
                    <div className='relative pb-6'>
                        <div className='relative z-20 w-full mx-auto default-px xl:px-[200px] pb-3'>
                            <LargeHeading as='h1' className='!text-3xl lg:text-center font-bold' balanced={true}>
                                {/*
==
                            <LargeHeading
                                as='h1'
                                className='!text-3xl lg:!text-[40px] xl:!text-[44px] 2xl:text-[48px] lg:text-center font-bold'
                                balanced={true}
                            >
>> development
*/}
                                Welcome to Muzology!
                            </LargeHeading>
                        </div>

                        <LargeText className='!text-2xl md:!text-2xl text-[#4B5563] text-center font-[600] my-4' balanced={true}>
                            Educators create your account to get started.
                        </LargeText>

                        <FormTeacherTrialSignup className='sm:mt-6' googleButton={false} />
                    </div>
                    <IconBlock icons={desktopFloatingHeartsPositions} className='hidden lg:block z-0' />
                </div>

                <div className='default-px'>
                    <div className='default-max-w mx-auto'>
                        <h5 className='text-center text-xl sm:text-4xl font-Inter font-medium text-[#131313] mb-4'>
                            <BalanceText>Muzology works. Experience the results with your students.</BalanceText>
                        </h5>
                        {/*
                        <h5 className='text-center text-xl sm:text-4xl font-Inter font-medium text-[#131313] mb-4'>
                            <BalanceText>
                                {components[1].heading}
                            </BalanceText>
                        </h5>
                        <SmallHeading className='text-center lg:text-center font-[500] text-[#131313] mb-2'>
                            <BalanceText>
                                {components[1].smallHeading}
                            </BalanceText>
                        </SmallHeading>
                        */}
                    </div>
                </div>

                {/*<LargeHeading className='lg:text-center xs:text-2xl default-px' balanced={true} heading='Muzology works. Experience the results with your students.' />*/}

                <BottomSection components={[components[0], components[6], components[5], components[2], components[3]]} noFAQ={true} />

                <style jsx>{`
                    #teacher-form {
                        //background-image: url('/assets/backgrounds/pricing-plan-bg.png'), url('/assets/backgrounds/howitworks-bg.png');
                        //background-image: url('/assets/backgrounds/pricing-plan-bg.png');
                        //background-image: url('/assets/backgrounds/howitworks-bg.png');
                        background-image: url('/backgrounds/bg-wavy-2.png');
                        background-repeat: no-repeat, no-repeat;
                        background-size: 100%, 100%;
                        background-position: 80% 100%, center;
                    }
                `}</style>
            </div>
        </Layout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('Signup');
}

export default Signup;
